"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../../core/table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _ref = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: 5,
  className: "text-xs-center cell-border-left"
}, "Competed and In Results"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: 2,
  className: "text-xs-right cell-border-left"
}, "Total PreEntered"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: 3,
  className: "text-xs-center cell-border-left"
}, "Entered But Not in Results")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right cell-border-left"
}, "Entered Online"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Entered By Post"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Entered On-The-Day"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Total"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Percentage PreEntered"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right cell-border-left"
}, "Entered Online"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Entered By Post"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Percentage")));
class EntrySourceStatsTable extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement(_table.default, null, _ref, /*#__PURE__*/_react.default.createElement("tbody", null, this.props.stats.map(row => /*#__PURE__*/_react.default.createElement("tr", {
      key: row.statsID
    }, /*#__PURE__*/_react.default.createElement("td", null, row.statsDescription), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right cell-border-left"
    }, row.competedAndEnteredOnline), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, row.competedAndPreEnteredByPost), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, row.enteredOnDay), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, row.totalCompeted), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, !row.totalCompeted ? '' : (Math.round(1000 * (row.competedAndPreEnteredByPost + row.competedAndEnteredOnline) / row.totalCompeted) / 10).toFixed(1) + '%'), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right cell-border-left"
    }, row.totalEntered), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right cell-border-left"
    }, row.enteredOnlineAndNotInResults), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, row.enteredByPostAndNotInResults), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, !row.totalEntered ? '' : (Math.round(1000 * (row.enteredOnlineAndNotInResults + row.enteredByPostAndNotInResults) / row.totalEntered) / 10).toFixed(1) + '%')))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = EntrySourceStatsTable;